import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";
import {
  AddCategoryMenuURL,
 
} from "../../assets/api/BaseURL";
import Notification from "../other/Notification";

const AddMenu = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setError("");
    setSuccess("");
  };

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      setTags([...tags, inputValue.trim()]);
      setInputValue("");
      setError("");
      setSuccess("");
    }
  };

  const handleTagClick = (tagIndex) => {
    const newTags = [...tags];
    newTags.splice(tagIndex, 1);
    setTags(newTags);
    setError("");
    setSuccess("");
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setError("");
    setSuccess("");
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const handleCategoryMenuClick = (e) => {
    e.preventDefault();
    navigate("/view_menus");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setError("");
    setSuccess("");
  };

  const handleAddMenu = async (e) => {
    e.preventDefault();

    if (formData.name.trim() === "") {
      setError("Menu name cannot be empty");
      setSuccess("");
    } else {
      const data = {
        name: formData.name.trim(),
        tags: tags.join(", "),
        description: formData.description,
        status: isChecked ? 1 : 0,
      };

      try {
        const response = await axios({
          method: "post",
          url: AddCategoryMenuURL,
          data: data,
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200 && response.data.message) {
          setError("");
          setSuccess(response.data.message);
          setFormData({
            name: "",
            description: "",
          });
          setTags([]);
          setInputValue("");
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setSuccess("");
        } else {
          setError(error.message);
          setSuccess("");
        }
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);

 

  useEffect(() => {
    if (error || success) {
      window.scrollTo(0, 0);
    }
  }, [error, success]);

  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                 {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar}/>
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="view_menus" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Categories</h3>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <div className="vsalign">
                                  <h4 className="card-title card-title-dash">
                                    Add Category
                                  </h4>
                                </div>
                                <div className="vsalign">
                                  <span
                                    className="btn btn-danger mb-0 me-0"
                                    onClick={handleCategoryMenuClick}
                                  >
                                    <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                                    Go Back
                                  </span>
                                </div>
                              </div>
                              <form className="forms-sample">
                                {error && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-danger">
                                    <div className="vsalign">{error}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setError("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {success && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-success">
                                    <div className="vsalign">{success}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSuccess("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div className="form-group">
                                  <label>
                                    Menu Name
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Menu Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Tags</label>
                                  <div id="tags">
                                    {tags.map((tag, index) => (
                                      <span
                                        key={index}
                                        onClick={() => handleTagClick(index)}
                                      >
                                        {tag}
                                      </span>
                                    ))}
                                    <input
                                      type="text"
                                      className=""
                                      value={inputValue}
                                      placeholder="Add a tag & hit Enter"
                                      onChange={handleInputChange}
                                      onKeyDown={handleInputKeyPress}
                                    />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label>Description</label>
                                  <textarea
                                    className="form-control"
                                    name="description"
                                    placeholder="Enter Description"
                                    value={formData.description}
                                    onChange={handleChange}
                                  ></textarea>
                                </div> */}
                                <div className="form-group togglecss">
                                  <label>Status</label>
                                  <div
                                    className={`button r ${isChecked ? "active" : ""
                                      }`}
                                    id="button-1"
                                  >
                                    <input
                                      type="checkbox"
                                      className="checkbox"
                                      checked={isChecked}
                                      onChange={handleCheckboxChange}
                                    />
                                    <div className="knobs"></div>
                                    <div className="layer"></div>
                                  </div>
                                </div>
                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                  onClick={handleAddMenu}
                                >
                                  Submit
                                </button>
                                <button
                                  className="btn btn btn-secondary"
                                  onClick={handleCategoryMenuClick}
                                >
                                  Cancel
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Notification />
        </>
      )}
    </>
  );
};

export default AddMenu;
